import React, { useContext, useEffect, useState } from "react";
import {
  Link,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Check, ChevronLeft, ShoppingCart } from "react-feather";
import { CartContext, UserContext } from "../../App";
import api from "../../api";
import TypeButton from "../../Component/typeButton";
import StyleButton from "../../Component/styleButton";

export default function ShopProduct() {
  const [params] = useSearchParams();
  const itemId = params.get("itemId");
  const { user } = useContext(UserContext);
  const { cart, cartDispatch } = useContext(CartContext);
  const navigate = useNavigate();
  // const { id } = useParams()
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [types, setTypes] = useState([]);
  const [styles, setStyles] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStyle, setSelectedStyle] = useState(null);
  // const imgPath = "https://images.pexels.com/photos/1852382/pexels-photo-1852382.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260;https://images.pexels.com/photos/594610/pexels-photo-594610.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260;https://images.pexels.com/photos/449977/pexels-photo-449977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  const images = product?.imgPath.split(";") ?? [];

  // const images = product?.imgPath
  // ? Array(3).fill(product?.imgPath)
  // : [];

  useEffect(() => {
    (async () => {
      const resp = await api.fetchProduct(itemId);
      if (resp.status == "error") {
        return history.replace("/404");
      }
      console.log("product details", resp);
      setProduct(resp[0]);
      setProducts(resp);
      const types = [
        ...new Map(
          resp
            .filter((p) => p.type_id != 0)
            .map((p) => [p.type_id, { id: p.type_id, name: p.type }]),
        ).values(),
      ];
      setTypes(types);
      setSelectedType(types[0]?.id);
      const styles = [
        ...new Map(
          resp
            .filter((p) => p.style_id != 0)
            .map((p) => [p.style_id, { id: p.style_id, name: p.style }]),
        ).values(),
      ];
      setStyles(styles);
      setSelectedStyle(styles[0]?.id);
      // setTypes([...new Set(resp?.map(p => p.type))]);
      // setStyles([...new Set(resp?.map(p => p.style))]);
    })();
  }, [itemId]);

  const addToCart = async (product, quantity = 1) => {
    console.log("product", product);
    if (user) {
      const resp = await api.addProductsToCart([
        { product: product, quantity },
      ]);
      if (resp) {
        cartDispatch({
          type: "ADD_PRODUCTS",
          payload: [{ ...product, quantity }],
        });
      }
    } else {
      cartDispatch({
        type: "ADD_PRODUCTS",
        payload: [{ ...product, quantity }],
      });
    }
  };

  useEffect(() => {
    (async () => {
      let filteredProduct = products;

      if (selectedType && !selectedStyle) {
        filteredProduct = products.filter((p) => p.type_id == selectedType);
        console.log("filtered Type Products", filteredProduct);
        setStyles([
          ...new Map(
            filteredProduct
              .filter((p) => p.style_id != 0)
              .map((p) => [p.style_id, { id: p.style_id, name: p.style }]),
          ).values(),
        ]);
        setSelectedStyle(styles[0]?.id);
      } else if (selectedType && selectedStyle) {
        filteredProduct = products.filter(
          (p) => p.style_id == selectedStyle && p.type_id == selectedType,
        );
        console.log("filtered Style Products", filteredProduct);
      }

      if (filteredProduct.length == 0) {
        setSelectedStyle(null);
        return;
      }
      setProduct(filteredProduct[0]);
      //  setProducts(filteredProduct)
    })();
  }, [selectedType, selectedStyle]);

  // if (!product) return <Loader />
  //     console.log("types",types);
  // 	console.log("styles",styles);

  return (
    <main className="container py-5">
      <div className="row g-5">
        {/* LEFT SIDE - IMAGES */}
        <div className="col-lg-6">
          <div
            className="border rounded-4 bg-white d-flex justify-content-center align-items-center"
            style={{
              height: "500px",
              overflow: "hidden",
            }}
          >
            <img
              src={images[activeIndex]}
              alt={product?.iName}
              className="img-fluid"
              style={{
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Thumbnails */}
          <div className="d-flex gap-2 mt-3 flex-wrap">
            {images.map((img, i) => (
              <div
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`border rounded p-2 cursor-pointer ${
                  activeIndex === i ? "border-success" : ""
                }`}
                style={{
                  width: "80px",
                  height: "80px",
                }}
              >
                <img
                  src={img}
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: "contain" }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE - DETAILS */}
        <div className="col-lg-6">
          {/* Breadcrumb */}
          <div className="text-muted small mb-3">Home / {product?.cat_name}</div>

          {/* Product Name */}
          <h1
            className="fw-bold mb-3"
            style={{
              fontSize: "2rem",
            }}
          >
            {product?.iName}
          </h1>

          {/* Description */}
          {product?.iDesc && (
            <p className="text-muted mb-4">{product?.iDesc}</p>
          )}

          {/* Price */}
          <div className="mb-4">
            {product?.discountPercent > 0 ? (
              <>
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="fw-bold text-primary"
                    style={{ fontSize: "2rem" }}
                  >
                    ₹{product?.tranRate?.toFixed(2)}
                  </span>

                  <span
                    className="text-decoration-line-through text-muted"
                    style={{ fontSize: "1.2rem" }}
                  >
                    ₹{product?.rate?.toFixed(2)}
                  </span>

                  <span className="badge bg-danger">
                    {product?.discountPercent}% OFF
                  </span>
                </div>
              </>
            ) : (
              <span
                className="fw-bold text-success"
                style={{ fontSize: "2rem" }}
              >
                ₹{product?.rate?.toFixed(2)}
              </span>
            )}
          </div>

          {/* Type */}
          {types?.length > 0 && (
            <>
              <h5 className="fw-bold mb-3">Select Type</h5>

              <div className="d-flex flex-wrap gap-2 mb-4">
                {types.map((t) => (
                  <TypeButton
                    key={t.id}
                    value={t.name}
                    selected={selectedType == t.id}
                    onClick={() => setSelectedType(t.id)}
                  />
                ))}
              </div>
            </>
          )}

          {/* Style */}
          {styles?.length > 0 && (
            <>
              <h5 className="fw-bold mb-3">Select Style</h5>

              <div className="d-flex flex-wrap gap-2 mb-4">
                {styles.map((s) => (
                  <StyleButton
                    key={s.id}
                    value={s.name}
                    selected={selectedStyle == s.id}
                    onClick={() => setSelectedStyle(s.id)}
                  />
                ))}
              </div>
            </>
          )}

          {/* Add To Cart */}
          <div className="mt-4">
            {cart?.products?.some((p) => p.itemId == itemId) ? (
                <button
                  className="btn btn-primary btn-lg"
                  style={{
                    minWidth: "220px",
                  }}
                  disabled
                >
                  ✓ Added To Cart
                </button>
            ) : (
              <button
                className="btn btn-primary btn-lg"
                style={{
                  minWidth: "220px",
                }}
                onClick={() => addToCart(product)}
                disabled={cart?.products?.some((p) => p.itemId == itemId)}
              >
                Add To Cart
              </button>
            )}
          </div>

          {/* Delivery Info */}
          <div
            className="border rounded-3 p-3 mt-5"
            style={{
              background: "#f8f9fa",
            }}
          >
            <h6 className="fw-bold">🚚 Fast Delivery</h6>

            <p className="mb-0 text-muted">
              Get your groceries delivered quickly at your doorstep.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
